export enum DepositStarting {
  Now = 'now',
  FutureDate = 'futureDate',
}

export type DepositTransferType =
  (typeof DEPOSIT_TRANSFER_TYPE)[keyof typeof DEPOSIT_TRANSFER_TYPE];

export const DEPOSIT_TRANSFER_TYPE = {
  EFT: 'EFT',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  EXTERNAL_TRANSFER: 'EXTERNAL_TRANSFER',
} as const;

export const TRANSFER_TYPES_WITHOUT_SCHEDULE: DepositTransferType[] = [
  DEPOSIT_TRANSFER_TYPE.EXTERNAL_TRANSFER,
  DEPOSIT_TRANSFER_TYPE.INTERNAL_TRANSFER,
];

export const PARTICIPANT_NUMBER_LENGTH = 4;
